export default function isFirefox() {
  return window.navigator.userAgent.match(/Gecko\//);
}